<template>
  <div>
    <order-view ref="base" :orderCode="params.code" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      fromData: {},
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === "detail"
    },
  },
  methods: {
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
